import { useLocation } from "react-router-dom";
import { Calculadora } from "@/components/Calculadora";
import { parseConfigFromSearch } from "@/lib/pricing";

export default function ClientPage() {
  const location = useLocation();
  const { config } = parseConfigFromSearch(location.search);

  return (
    <div className="min-h-screen bg-[#f4f5fa]">
      <header className="border-b border-[#e6e7f0] bg-white">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/motivy-logo.png"
              alt="Motivy"
              className="h-8 sm:h-9 w-auto"
              data-testid="motivy-logo"
            />
            <div className="leading-tight border-l border-[#e6e7f0] pl-3">
              <p className="text-[11px] text-[#6c6d85] font-medium">Propuesta para USFQ</p>
            </div>
          </div>
          <span className="text-xs font-medium text-[#6c6d85] hidden sm:block">
            Calculadora de precios
          </span>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 sm:px-8 py-8 sm:py-12">
        <div className="mb-8 max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-wider text-[#ff5566] mb-2">
            Propuesta Motivy · USFQ
          </p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#24255b]">
            Calculadora de precios
          </h1>
          <p className="mt-3 text-base text-[#6c6d85]">
            Personaliza el alcance del plan y descubre al instante cuánto valor en servicios de
            bienestar reciben los estudiantes de la USFQ por un costo institucional muy bajo.
          </p>
        </div>

        <Calculadora config={config} />

        <footer className="mt-12 text-center text-xs text-[#6c6d85]">
          Motivy · Propuesta confidencial para USFQ
        </footer>
      </main>
    </div>
  );
}
